"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.SnackbarContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  left: 50%;\n  top: 40px;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  width: calc(100% - 32px);\n  max-width: 424px;\n  padding: 16px;\n  background-color: ", ";\n"], ["\n  position: fixed;\n  left: 50%;\n  top: 40px;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  width: calc(100% - 32px);\n  max-width: 424px;\n  padding: 16px;\n  background-color: ", ";\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.snackbar.backgroundColor;
});
exports.SnackbarMessage = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 14px;\n  color: ", ";\n  opacity: 0.9;\n"], ["\n  font-size: 14px;\n  color: ", ";\n  opacity: 0.9;\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.snackbar.textColor;
});
var Snackbar = function (props) {
    var message = props.message;
    return (react_1.default.createElement(exports.SnackbarContainer, null,
        react_1.default.createElement(exports.SnackbarMessage, null, message)));
};
exports.default = Snackbar;
var templateObject_1, templateObject_2;
